module.exports = __webpack_public_path__ + "static/media/14-vert.406972c2.mp3";